import { SortOrder } from "@common/constants";
import {
    FinancialDocumentSort,
    FinancialDocumentSortField,
} from "@common/schemas/financialDocument/financial-document-query.schema";
import { FinancialDocumentSortValue } from "@common/types/views/financialDocumentViews";

export const getSortExpression = (
    sort: FinancialDocumentSortValue,
): FinancialDocumentSort | undefined => {
    switch (sort) {
        case FinancialDocumentSortValue.UPLOAD_DATE_DESC:
            return {
                field: FinancialDocumentSortField.CREATED_AT,
                order: SortOrder.DESC,
            };
        case FinancialDocumentSortValue.UPLOAD_DATE_ASC:
            return {
                field: FinancialDocumentSortField.CREATED_AT,
                order: SortOrder.ASC,
            };
        case FinancialDocumentSortValue.NAME_DESC:
            return {
                field: FinancialDocumentSortField.FILE_NAME,
                order: SortOrder.DESC,
            };
        case FinancialDocumentSortValue.NAME_ASC:
            return {
                field: FinancialDocumentSortField.FILE_NAME,
                order: SortOrder.ASC,
            };
        default:
            return undefined;
    }
};
